import { DATA_WELL, DONUT, PIE, TABLE, AREA, BAR, COLUMN, LINE } from 'reporting-data/constants/chartTypes';
import { CUSTOM_WIDGET_TYPES } from 'reporting-data/tsTypes/customWidgetTypes';
export const DYANMIC_GOAL = 'dynamicGoal';
export const STATIC_GOAL = 'staticGoal';
export const GOAL_EDITOR_MAX_REPORT_DIMENSIONS = 1;
export const STATIC_LINE_SUPPORTED_CHART_TYPES = [AREA, BAR, COLUMN, LINE];
export const GOAL_EDITOR_EXCLUDED_CHART_TYPES = [DONUT, PIE, TABLE, DATA_WELL];
export const GOAL_EDITOR_EXCLUDED_CUSTOM_WIDGETS = [CUSTOM_WIDGET_TYPES.SALES_QUOTA];
export const REPORT_OBJECT_ID_COUNT_PROPERTY = 'count';